import { Dispatch } from 'redux'

import anchor from '../../../constants/anchor'
import removeFromListDelay from '../../../constants/removeFromListDelay'
import { apiInstance } from '../../api/apiInstance'
import { RootState } from '../../store/rootReducer'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

const setPartArchivedStatus =
    (partId: string, newArchivedStatus = true) =>
    async (dispatch: Dispatch, getState: () => RootState): Promise<void> => {
        const { userData } = getState()
        try {
            const {
                data: { status },
            } = await apiInstance.post(
                '/setPartArchivedStatus',
                {
                    userId: userData.smsAuth.userId,
                    partId,
                    newArchivedStatus,
                },
                {
                    headers: {
                        Authorization: `${anchor} ${localStorage.getItem('accessToken')}`,
                    },
                },
            )
            if (status === 'ok') {
                dispatch({
                    type: storeDispatchTypes.setPartArchivedStatus,
                    value: {
                        id: partId,
                        isArchived: newArchivedStatus,
                    },
                })

                setTimeout(() => {
                    dispatch({
                        type: storeDispatchTypes.removeArchivedPartFormList,
                        value: {
                            id: partId,
                        },
                    })
                }, removeFromListDelay)
            }
        } catch (e) {
            console.error('set part archived status failed', e)
        }
    }

export default setPartArchivedStatus
